import { Button } from "./Button";

interface PaginationBarProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  itemCount?: number;
  totalCount?: number;
  itemLabel?: string;
}

export const PaginationBar = ({
  page,
  totalPages,
  onPageChange,
  itemCount,
  totalCount,
  itemLabel = "registros",
}: PaginationBarProps) => {
  if (totalPages <= 1) return null;
  return (
    <nav
      aria-label="Paginación"
      className="flex items-center justify-between text-xs text-ink-secondary"
    >
      {typeof itemCount === "number" && typeof totalCount === "number" ? (
        <p>
          Mostrando {itemCount} de {totalCount} {itemLabel}
        </p>
      ) : (
        <span />
      )}
      <div className="flex gap-1">
        <Button
          size="sm"
          variant="secondary"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          aria-label="Ir a la página anterior"
        >
          ← Anterior
        </Button>
        <span className="px-3 py-1" aria-current="page" aria-label={`Página ${page} de ${totalPages}`}>
          {page} / {totalPages}
        </span>
        <Button
          size="sm"
          variant="secondary"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          aria-label="Ir a la página siguiente"
        >
          Siguiente →
        </Button>
      </div>
    </nav>
  );
};
